module.exports = __webpack_public_path__ + "fonts/Inter_28pt-Light.woff";